import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {PlacedOrderProduct} from "@/data/entities/product";
import Product from "@widgets/pos/orders/details/order/overview/summary/products/Product";

type Props = {
    order: PlacedOrderOverview,
};

const ProductList = ({order}: Props) => {
    return (
        <ul className={"col-span-3 w-full flex flex-col items-start justify-start"}>
            {order.products.map((product: PlacedOrderProduct, i: number) =>
                <li
                    key={i}
                    className={"w-full pb-3 mb-3 border-b border-gray-100 dark:border-slate-700"}
                >
                    <Product product={product}/>
                </li>
            )}
        </ul>
    );
};

export default ProductList;